export default __webpack_public_path__ + "static/media/2.6c468f0c.svg";